import React from 'react';
import ReactDOM from 'react-dom';
import Router from './components/Router.js';
ReactDOM.render(<Router />, document.getElementById('root'));
